import { createElement } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { classes } from './Stack';
import type { Space } from './Stack';

/**
 * Things side by side — buttons, a badge beside a figure — that wrap to the next line when there is no room (DS-9a).
 * The default gap is 5 (10px), a header's actions' gap; centred on the cross axis unless `align` says otherwise.
 */
export function Cluster({
  as = 'div',
  gap = 5,
  align = 'center',
  justify = 'start',
  wrap = true,
  className,
  children,
  ...props
}: HTMLAttributes<HTMLElement> & {
  as?: 'div' | 'span' | 'ul' | 'ol';
  gap?: Space;
  align?: 'center' | 'baseline' | 'start' | 'end';
  justify?: 'start' | 'end' | 'between';
  wrap?: boolean;
  children?: ReactNode;
}) {
  return createElement(
    as,
    {
      ...props,
      className: classes(
        'wb-cluster',
        gap !== 5 && `wb-cluster--g${gap}`,
        align !== 'center' && `wb-cluster--align-${align}`,
        justify === 'end' && 'wb-cluster--justify-end',
        justify === 'between' && 'wb-cluster--between',
        !wrap && 'wb-cluster--nowrap',
        className,
      ),
    },
    children,
  );
}
